import { isEqual } from 'underscore';
import { isSameAttendee } from '@shoflo/studio-redux/utils/actionUtils';
import setSceneLayout from '@shoflo/studio-redux/actions/program/setSceneLayout';
import { SceneLayouts, SINGLE } from '@studio/constants/SceneLayouts';
import setProgram from './setProgram';

function syncProgram({ program: updatedProgram, notifyingDirector }) {
  return (dispatch, getState) => {
    const state = getState();
    const { program } = state;
    if (!isEqual(program, updatedProgram)) {
      if (!isSameAttendee(notifyingDirector, state)) {
        const layout = SceneLayouts.find(
          l => l.id === updatedProgram?._id || l.id === updatedProgram?.layout
        );

        dispatch(setSceneLayout(layout || SINGLE));
        dispatch(setProgram(updatedProgram, true, { emitSocket: false }));
      }
    }
  };
}

export default syncProgram;
